import LogoHeader from "./../assets/images/icons/logo1.png";
import LogoShort from "./../assets/images/icons/logo2.png";
import Documenticon from "./../assets/images/icons/logo1.png";

const IMAGES = {
  LogoHeader: LogoHeader,
  LogoShort: LogoShort,
  Documenticon: Documenticon,
};
export default IMAGES;
